import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import DetailsModalHeader from './details-modal-header';
import "./details-modal.css";

class DetailsModal extends Component {
    render() {
        return (
            <div className="details-modal-container">
                <Modal
                id={null}
                show={this.props.showModal}
                onHide={this.props.handleClose}
                backdrop="static"
                keyboard={false}
                size={this.props?.size}
                enforceFocus={false}
                className={`details-modal ${this.props.customClassName}`}
                >
                    <DetailsModalHeader title={this.props.title} />
                    <Modal.Body>
                        {this.props.children}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export default DetailsModal;